import { render, staticRenderFns } from "./ArticleShortcut.vue?vue&type=template&id=14cf2eab&"
import script from "./ArticleShortcut.vue?vue&type=script&lang=js&"
export * from "./ArticleShortcut.vue?vue&type=script&lang=js&"
import style0 from "./ArticleShortcut.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules_dev/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports